// extracted by mini-css-extract-plugin
module.exports = {"instruction":"style_instruction__n4V9n","light":"style_light__LVqCs"};